import { useEffect, useState } from "react";
import { Download, FileText, Search } from "lucide-react";

import api, { API } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Loading } from "../../components/shared";

export default function ResidentDocuments() {
  const [documents, setDocuments] = useState(null);
  const [filters, setFilters] = useState({ q: "", category: "" });

  useEffect(() => {
    const timer = window.setTimeout(() => {
      api
        .get("/resident-communications/documents", { params: filters })
        .then((response) => {
          setDocuments(response.data);
        })
        .catch(() => setDocuments([]));
    }, 180);
    return () => window.clearTimeout(timer);
  }, [filters]);

  if (!documents) return <Loading />;
  return (
    <div data-testid="resident-documents-page">
      <header className="border-b border-slate-200 pb-6">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
          Reference library
        </p>
        <h1 className="mt-2 font-display text-4xl font-bold text-slate-900">
          Society Documents
        </h1>
      </header>
      <section
        className="mt-6 grid gap-3 border border-slate-200 bg-white p-4 sm:grid-cols-2"
        data-testid="resident-document-filters"
      >
        <label className="relative">
          <Search className="pointer-events-none absolute left-3 top-3 h-4 w-4 text-slate-400" />
          <Input
            className="pl-9"
            data-testid="resident-document-search"
            onChange={(event) =>
              setFilters({ ...filters, q: event.target.value })
            }
            placeholder="Search documents"
            value={filters.q}
          />
        </label>
        <Input
          data-testid="resident-document-category-filter"
          onChange={(event) =>
            setFilters({ ...filters, category: event.target.value })
          }
          placeholder="Filter category"
          value={filters.category}
        />
      </section>
      <section
        className="mt-6 grid gap-4 sm:grid-cols-2"
        data-testid="resident-document-list"
      >
        {documents.length ? (
          documents.map((document) => (
            <article
              className="border border-slate-200 bg-white p-5"
              data-testid={`resident-document-${document.doc_id}`}
              key={document.doc_id}
            >
              <FileText className="h-5 w-5 text-blue-700" />
              <p className="mt-5 text-xs font-semibold text-blue-700">
                {document.category}
              </p>
              <h2 className="mt-1 font-display text-xl font-semibold text-slate-900">
                {document.title}
              </h2>
              <p className="mt-2 text-sm leading-6 text-slate-600">
                {document.description || document.filename}
              </p>
              <a
                className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-blue-700 hover:text-blue-900"
                data-testid={`resident-document-download-${document.doc_id}`}
                href={`${API}/resident-communications/documents/${document.doc_id}/download`}
                rel="noreferrer"
                target="_blank"
              >
                <Download className="h-4 w-4" />
                Download
              </a>
            </article>
          ))
        ) : (
          <p
            className="border border-dashed border-slate-300 bg-white p-7 text-sm text-slate-600"
            data-testid="resident-document-empty"
          >
            No resident documents are available for your current Society and
            home access.
          </p>
        )}
      </section>
    </div>
  );
}
